import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import LoadingCard from 'components/loading/LoadingCard';
import translate from 'components/hoc/translate';
import { fetchProductMemberships } from 'store/actions/product-memberships/fetchProductMemberships';
import ProductMembershipsList from './ProductMembershipsList';

class ProductMembershipsContainer extends Component {
    componentDidMount() {
        const { fetchProductMemberships } = this.props;

        fetchProductMemberships();
    }

    render() {
        const { id, memberships, loading, resource } = this.props;

        if (loading) {
            return <LoadingCard />;
        }

        return (
            <ProductMembershipsList
                productId={ id }
                memberships={ memberships }
                resource={ resource }
            />
        );
    }
}

ProductMembershipsContainer.propTypes = {
    memberships: PropTypes.object,
    fetchProductMemberships: PropTypes.func,
    id: PropTypes.string.isRequired,
    loading: PropTypes.bool,
    resource: PropTypes.string,
};

const mapStateToProps = (state, props) => {
    const { resource } = props;

    return {
        memberships: state[resource].data,
        loading: state[resource].loading,
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        fetchProductMemberships: () => {
            dispatch(fetchProductMemberships({
                product_id: props.id,
            }));
        },
    };
};

const enhance = compose(
    connect(mapStateToProps, mapDispatchToProps),
    translate,
);

export default enhance(ProductMembershipsContainer);


// WEBPACK FOOTER //
// ./src/pages/products/memberships/ProductMembershipsContainer.js